import React, { useState, useEffect } from 'react';
import ButtonBack from 'components/button/ButtonBack';
import DropdownButtonSelect from 'components/button/DropdownButtonSelect';
import InputCheckBox from 'components/input/InputCheckBox';
import { useLocale } from 'components/special/LanguageProvider';

const ActionFooter = ({ actioninit, performAction, onSubmit, onCancel, disabled, showSkipLetter, updateSkipLetter}) => {   

    const [formList, setFormList] = useState([]);
    const [defaultFormID, setDefaultFormID] = useState(0);
 
    const onSelectClick = (item) => {
        performAction.signatureID = item.item;
    }
    
    const onSaveClick = (item) => {
        performAction.formID = item.item;
        onSubmit();
    }

    const findFormListForAction = (actionID) => {
        if (actioninit && actioninit.forms){
            let actionForms = actioninit.forms.find(forms => forms.actionID == actionID);
            if (actionForms){
                return actionForms;
            }
            return {
                forms : [],
                defaultFormID : 0
            }
        }
    }

    useEffect(() => {
        if (actioninit.forms != undefined){
            let actionForm = findFormListForAction(actioninit.actionData.actionID);
            if (actionForm){
                setDefaultFormID(actionForm.defaultFormID);
                setFormList(actionForm.forms);
            }else{
                setDefaultFormID(null);
                setFormList([]);
            }
        }
    }, [actioninit.forms]);

    return (
        <div className="grid collapse840">
            <div className="col s2of5">
                <div className="form grid collapse840">
                    <div className="col s1of2">
                        <ButtonBack text="Til baka" onClick={onCancel} />
                    </div>
                    { showSkipLetter && <div className="col s1of2 pull-right grid collapse840">
                        <div className="col s1of8">
                            <InputCheckBox value={performAction.skipLetter} onChange={(value) => updateSkipLetter(value)} disabled={false}/>
                        </div>
                        <div className="col 7of8">
                            <label>Sleppa kvittun</label>
                        </div>
                    </div>}
                </div>
            </div>
        <div className="col s3of5 float-right text-right">
            {formList.length > 0 &&
            <DropdownButtonSelect
                buttonClass="gray"
                buttonTriggerClass="gray"
                buttonGroupClass="pull-right"
                placement="top"
                icon="icon-file3"
                listData={formList}
                nameObject="name"
                buttonAction={onSaveClick}
                initialItem={defaultFormID}
                useKeyField="true"
                keyField="itemID"/>}
            {actioninit.signatures && actioninit.signatures.length > 0 && 
            <DropdownButtonSelect 
                buttonClass="gray-light"
                buttonTriggerClass="gray-light"
                buttonGroupClass="pull-right"
                placement="top"
                icon="icon-pencil4"
                listData={actioninit.signatures}
                nameObject="name"
                singleAction="true"
                buttonAction={onSelectClick}
                initialItem={actioninit.defaultSignatureID}
                useKeyField="true"
                keyField="itemID"/>}
        </div>
        </div>   
      );
};

export default ActionFooter;
